import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ShipFromContactModal } from 'ui-components/components/shipfrom-contact-modal';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { addShipFromContact, extractErrorCollectionToMessageList } from '../../../carrier-pickup/carrier-pickup-api';

export const NewShipFromContactModal = ({ onCreate, onCancel, shipFromId, showDefaultLocationNotes = false, onClose }) => {
  const [isSaving, setIsSaving] = useAsyncSafeState(false);
  const [errorCollection, setErrorCollection] = useAsyncSafeState([]);

  const onSubmit = useCallback(
    (newContact) => {
      setIsSaving(true);

      addShipFromContact(shipFromId, newContact)
        .then(({ data }) => onCreate(data))
        .catch(({ response }) => setErrorCollection(extractErrorCollectionToMessageList(response, [])))
        .finally(() => setIsSaving(false));
    },
    [shipFromId, onCreate, setErrorCollection, setIsSaving],
  );

  const closeModal = useCallback(() => {
    if (!isSaving) {
      onCancel();
    }
  }, [isSaving, onCancel]);

  return (
    <ShipFromContactModal
      errorCollection={errorCollection}
      isSaving={isSaving}
      onCancel={closeModal}
      onClose={onClose}
      onSubmit={onSubmit}
      showDefaultLocationNotes={showDefaultLocationNotes}
    />
  );
};

NewShipFromContactModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  shipFromId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showDefaultLocationNotes: PropTypes.bool,
};
